module.exports = __webpack_public_path__ + "static/media/test5_3.e98eaeee.png";